import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { AdminContractListComponent } from './contract-list/contract-list.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';

export const ADMIN_REQUEST_ROUTES = {
  ASSET_DOCUMENT: 'asset-document',
  CONTRACT_MODIFICATIONS: 'contract-modifications',
  CLIENT_DATA: 'client-data',
};

const routes: Routes = [
  {
    path: 'client-contracts',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [{ path: '', component: AdminContractListComponent }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AdminContractsRoutingModule {}
